import * as _actions from './actions';
import _reducer from './reducer';
import _Essay from './model';

export const actions = _actions;
export const reducer = _reducer;
export const Essay = _Essay;



// WEBPACK FOOTER //
// ./data/WritingAssignment/Essay/index.js